import { memo, useEffect, useRef, useState } from "react"
import { HStack, Input, Center, AspectRatio, Image, Float, Tag, Button } from "@chakra-ui/react"
import { InputGroup } from "@/components/ui/input-group"
import { LuSearch, LuShoppingCart, LuMessageCircle } from "react-icons/lu"
import Slider from "react-slick";
import _ from "lodash";
import { useNavigate } from "react-router"
import ProductCarousel from "./ProductCarousel";
import SmallProductCarousel from "./SmallProductCarousel";
import ProductAll from "./ProductAll";
import ProductList from "./ProductList";
import { useStoreProduct } from "contexts/store_product";
const ProductBlock = ({ data }) => {
    const [productList, setProductList] = useState([]);
    const { products, getProductsByList, getProductByFilter } = useStoreProduct();
    useEffect(() => {
        loadProductList();
    }, [products, data])
    const loadProductList = async () => {
        if (data.setting.products.method == "list") {
            var lst = await getProductsByList(data.setting.products.list);
            setProductList(lst);
        } else {
            var filter = {

            }
            if (data.setting.products.method == "tag") {
                filter.tag = data.setting.products.tag;
            }
            if (data.setting.products.method == "category") {
                filter.category = data.setting.products.category;
            }

            var lst = await getProductByFilter(filter);
            setProductList(lst);
        }
    }



    var listToShow = products;
    //  getProductsByList()

    switch (data.setting.display) {
        case "list":
            return <ProductList data={productList}></ProductList>
        case "carousel":
            return <ProductCarousel data={productList} settings={{ slide_config: data.setting.slide_config ?? {} }}></ProductCarousel>
        case "carousel_small":
            return <SmallProductCarousel data={productList} settings={{ slide_config: data.setting.slide_config ?? {} }} ></SmallProductCarousel>
        case "all":
            return <ProductAll data={products}></ProductAll>
    }

}

export default memo(ProductBlock)